import { Badge, Dropdown, Grid, Image } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Hamburger from "../../../../../assets/images/icons/Hamburger";
import ShopingCart from "../../../../../assets/images/icons/ShopingCart";
import UserCircle from "../../../../../assets/images/icons/UserCircle";
import { LanguageDropdown } from "../../../../../components";
import { P1 } from "../../../../../components/NormalFonts";
import { useAuth } from "../../../../../context/AuthContext";
import { useLayout } from "../../../../../context/LayoutContext";
import { MenuType } from "../../data";
import styles from "./styleModule";

const HeaderContainer = ({
  handleLogoClick,
  handleLoginClick,
  onMenuOpen,
  messageUnread,
  MENU,
  PROFILE,
  cartStatus,
}: {
  handleLogoClick: () => void;
  handleLoginClick: () => void;
  onMenuOpen: () => void;
  messageUnread: {
    has_unread_message: boolean;
  };
  MENU: MenuType[];
  PROFILE: MenuType[];
  cartStatus: boolean;
}) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { getHeaderPadding, getHeaderHeight } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [showLanguageDrawer, setShowLanguageDrawer] = useState<boolean>(false);

  const getMenuGap = () => {
    if (screens.xl) return "var(--menu-gap-xl)";
    if (screens.lg) return "var(--menu-gap-lg)";
    if (screens.md) return "var(--menu-gap-md)";
    return "16px";
  };

  const getMenuFontSize = () => {
    if (screens.lg) return "var(--menu-fontsize-lg)";
    if (screens.md) return "var(--menu-fontsize-md)";
    return "var(--menu-fontsize-md)";
  };

  const renderMenu = () => {
    if (screens.md) {
      return MENU.filter((_menu: MenuType) => _menu.visible === true).map(
        (_menu: MenuType) => {
          return (
            <Link
              style={{ fontSize: getMenuFontSize() }}
              className={`${styles.menu} ${
                window.location.pathname ===
                  `${process.env.PUBLIC_URL}${_menu.path}` ||
                (window.location.pathname.includes(
                  `${process.env.PUBLIC_URL}${_menu.extraPath}`
                ) &&
                  !_menu.ignorePath?.includes(window.location.pathname))
                  ? styles.active
                  : ""
              }`}
              // onClick={() => handleScroll(_menu.key)}
              to={_menu.path}
              key={_menu.key}
            >
              {_menu.label}
            </Link>
          );
        }
      );
    }
  };

  const getDropdownItem = () => {
    return PROFILE.filter((_profile) => _profile.visible === true).map(
      (_profile) => {
        return {
          key: _profile.key,
          label: (
            <div
              className={`${styles.menuitem} ${
                window.location.pathname === _profile.path ? styles.active : ""
              }`}
              onClick={
                _profile.onClick
                  ? _profile.onClick
                  : () => navigate(_profile.path)
              }
            >
              <Badge dot={_profile.dot}>
                <P1 color="var(--Neutral-dark-70)">{_profile.label}</P1>
              </Badge>
            </div>
          ),
        };
      }
    );
  };

  const renderLogin = () => {
    if (screens.md) {
      if (!isAuthenticated) {
        return (
          <>
            <Badge dot={cartStatus ? cartStatus : false}>
              <div onClick={handleLoginClick} className={styles.icon}>
                <ShopingCart
                  style={{ fontSize: 24, color: "var(--primary)" }}
                />
              </div>
            </Badge>
            <div onClick={handleLoginClick} className={styles.icon}>
              <UserCircle style={{ fontSize: 24, color: "var(--primary)" }} />
            </div>
          </>
        );
      }
      return (
        <>
          <Badge dot={cartStatus ? cartStatus : false}>
            <div
              onClick={() => {
                navigate("/cart");
              }}
              className={styles.icon}
            >
              <ShopingCart style={{ fontSize: 24, color: "var(--primary)" }} />
            </div>
          </Badge>
          <Dropdown
            menu={{ items: getDropdownItem() }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Badge dot={messageUnread?.has_unread_message || false}>
              <div className={styles.icon}>
                <UserCircle style={{ fontSize: 24, color: "var(--primary)" }} />
              </div>
            </Badge>
          </Dropdown>
        </>
      );
    }

    return (
      <div className={styles.loginContainer}>
        <Badge dot={cartStatus ? cartStatus : false}>
          <div
            onClick={() => {
              if (!isAuthenticated) {
                handleLoginClick();
                return;
              }
              navigate("/cart");
            }}
            className={styles.icon}
          >
            <ShopingCart style={{ fontSize: 24, color: "var(--primary)" }} />
          </div>
        </Badge>
        <LanguageDropdown
          showDrawer={showLanguageDrawer}
          setShowDrawer={setShowLanguageDrawer}
        />
      </div>
    );
  };

  return (
    <div
      className={`${styles.headerContainer} header-container`}
      style={{
        padding: getHeaderPadding(),
        background: "#FFF",
      }}
      id="header-container"
    >
      <div
        className={`${styles.headerBar} ${screens.lg ? "" : styles.middle} ${
          screens.md ? "" : styles.small
        }`}
        style={{
          height: getHeaderHeight(),
        }}
      >
        <div className={styles.componentLeft}>
          <Image
            src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
            preview={false}
            className={`${styles.logo} ${screens.md ? "" : styles.small}`}
            onClick={handleLogoClick}
          />
        </div>
        <div className={styles.menuWrapper}>
          <div
            className={styles.componentCenter}
            style={{
              gap: getMenuGap(),
            }}
          >
            {renderMenu()}
          </div>
        </div>
        <div className={styles.componentRight}>
          {renderLogin()}

          {screens.md ? (
            <LanguageDropdown
              showDrawer={showLanguageDrawer}
              setShowDrawer={setShowLanguageDrawer}
            />
          ) : (
            <Badge
              dot={messageUnread?.has_unread_message || false}
              offset={[-1, 1]}
            >
              <div
                className={styles.icon}
                onClick={onMenuOpen}
                style={{ fontSize: 24, color: "var(--primary)" }}
              >
                <Hamburger />
              </div>
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderContainer;
